/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import { Pair, mk_pair } from 'widgets-for-react'
import { ImageSize } from '../../cms/blocks/types.gen'

export type ExtraImages =
  // Old Page Header + CTA block:
  | '640w'
  | '1280w'
  | '1920w'
  | '2880w'

  // New Page Header:
  | '425w'
  | '850w'
  | '1225w'

  // Grid Block + Stories Block:
  | 'grid'
  | '720x470'
  | '1440x940'

  // Text + Image block:
  | '720w'
  | '1440w'

  // Media block:
  | 'media'
  | '460w'
  | '920w'
  | '1840w'

  // Quotes - Time-Line - Featured Content Blocks:
  | '450x450'
  | '600x600'
  | '1200x1200'

  // CTA Block:
  | '700w'
  | '1400w'
  | '2800w'

  // OLD PROJECT - Featured Content Block + Media Block + Image Gallery + Page Header:
  | '640w'
  | '1280w'
  | '1920w'
  | '2880w'

  // Quote Block:
  | '640x360'
  | '1280x720'

export type extra_images = ExtraImages

export const get_default_data_src: () => ImageSize<extra_images> = () => 'full'
export const get_default_data_srcset: () => Pair<ImageSize<extra_images>, string>[] = () => [
]

// 425
export const newpageheader_src: () => ImageSize<ExtraImages> = () => '425w'
export const newpageheader_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('425w' as ExtraImages, '425w'),
  mk_pair('850w' as ExtraImages, '850w'),
  mk_pair('1225w' as ExtraImages, '1225w'),
]

// ----- 460w

export const mediablock_src: () => ImageSize<ExtraImages> = () => 'media'
export const mediablock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('920w' as ExtraImages, 'media'),
  mk_pair('1840w' as ExtraImages, '1840w')
]

// ----- 700w

export const ctablock_src: () => ImageSize<ExtraImages> = () => '700w'
export const ctablock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('700w' as ExtraImages, '700w'),
  mk_pair('1400w' as ExtraImages, '1400w'),
  mk_pair('2800w' as ExtraImages, '2800w'),
]

// ----- 720

export const linkgridblock_src: () => ImageSize<ExtraImages> = () => 'grid'
export const linkgridblock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('grid' as ExtraImages, '720w'),
  mk_pair('full' as ExtraImages, 'full')
]

export const textimageblock_src: () => ImageSize<ExtraImages> = () => '720w'
export const textimageblock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('720w' as ExtraImages, '720w'),
  mk_pair('1440w' as ExtraImages, '1440w'),
]

export const timelineblock_src: () => ImageSize<ExtraImages> = () => '450x450'
export const timelineblock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('450x450' as ExtraImages, '450x450'),
  mk_pair('600x600' as ExtraImages, '600x600'),
  mk_pair('1200x1200' as ExtraImages, '1200x1200')
]

export const quotesblock_src: () => ImageSize<ExtraImages> = () => '450x450'
export const quotesblock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('450x450' as ExtraImages, '450x450'),
  mk_pair('600x600' as ExtraImages, '600x600'),
  mk_pair('1200x1200' as ExtraImages, '1200x1200')
]

// ----- OLD PROJECT - not needed

export const featuredblock_src: () => ImageSize<ExtraImages> = () => '640w'
export const featuredblock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('640w' as ExtraImages, '640w'),
  mk_pair('1280w' as ExtraImages, '1280w'),
  mk_pair('1920w' as ExtraImages, '1920w'),
  mk_pair('2880w' as ExtraImages, '2880w')
]

export const gallery_src: () => ImageSize<ExtraImages> = () => '1280w'
export const gallery_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('1280w' as ExtraImages, '1280w'),
  mk_pair('1920w' as ExtraImages, '1920w'),
  mk_pair('2880w' as ExtraImages, '2880w')
]

export const quoteblock_src: () => ImageSize<ExtraImages> = () => '640x360'
export const quoteblock_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('640x360' as ExtraImages, '640w'),
  mk_pair('1280x720' as ExtraImages, '1280w')
]

export const overviewpage_src: () => ImageSize<ExtraImages> = () => 'thumbnail'
export const overviewpage_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
  mk_pair('thumbnail' as ExtraImages, '150w'),
  mk_pair('medium_large' as ExtraImages, '700w'),
  mk_pair('large' as ExtraImages, '920w')
]

// export const pageheader_src: () => ImageSize<ExtraImages> = () => '640w'
// export const pageheader_srcset: () => Pair<ImageSize<ExtraImages>, string>[] = () => [
//   mk_pair('640w' as ExtraImages, '640w'),
//   mk_pair('1280w' as ExtraImages, '1280w'),
//   mk_pair('1920w' as ExtraImages, '1920w'),
//   mk_pair('2880w' as ExtraImages, '2880w')
// ]